<template>
  <div class="container">
    <h1>Туршилт xийгдэж байна</h1>
    <div class="card-deck">
      <!-- <div class="card">
        <div class="card-header">sdfsadfsadfsdf</div>
        <div class="card-body">
          <div class="chart-wrapper">
            <raddar-chart />
          </div>
        </div>
      </div> -->

      <div class="card">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="chart-wrapper">
            <bar-chart />
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="chart-wrapper">
            <scores-histogram />
          </div>
        </div>
      </div>
      
    </div>
    <div class="card-deck">
      <div class="card">
        <div class="card-header"></div>
        <div class="card-body">
          <div class="chart-wrapper">
            <weekly-timeline />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import { mapState } from "vuex";
const fb = require("../firebaseConfig.js");
import myfunction from "./global/myfunction.js";
import timetable from "./school/shared/timetable.js";
import RaddarChart from "./charts/RaddarChart";
import BarChart from "./charts/BarChart";
import WeeklyTimeline from "./charts/WeeklyTimeline";
import ScoresHistogram from "./charts/ScoresHistogram"

import axios from "axios";

export default {
  name: "MyDashboard",
  components: {
    RaddarChart,
    BarChart,
    WeeklyTimeline,
    ScoresHistogram
  },
  data() {
    return {
      customerData: null,
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  mixins: [timetable, myfunction],
  methods: {},
  created() {},
};
</script>

<style scoped>
.schedule-cell:hover {
  /* background-color:#f0f6ff; */
  background-color: #fff3cd;
}
</style>
